import colors from './colors';

export default {
  danger: colors.roman,
  invalid: colors.bombay,
  success: colors.gulfstream,
  warning: colors.apricot,
};
